module.exports = __webpack_public_path__ + "static/media/fr.1e1e3f8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/fr.png
// module id = 114
// module chunks = 0